import React from 'react';

import { Button, Card, Table, Tooltip, Typography } from 'antd';

import { useDownload } from 'v2/hooks/useDownload';

import { Icon } from '@eduzz/ui-antd-theme';

function Logo() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      id='logo_myeduzz'
      data-name='logo_myeduzz'
      viewBox='0 0 1666.88 400'
      className='max-w-35'
    >
      <defs>
        <style>{'.cls-1 { fill: #f9b122; }.cls-2 { fill: #00264d; }'}</style>
      </defs>
      <g>
        <path
          className='cls-2'
          d='M955.02,148c-9.78-5.87-21.24-8.8-34.4-8.8s-25.38,3.02-35.59,9.07c-10.23,6.05-18.13,14.4-23.73,25.06-5.6,10.67-8.4,23.11-8.4,37.33s2.84,25.78,8.53,36.26c5.69,10.49,13.6,18.62,23.73,24.4,10.13,5.77,21.86,8.67,35.19,8.67,10.49,0,19.91-1.91,28.26-5.73,8.35-3.82,15.37-9.07,21.07-15.73,5.69-6.67,9.78-14.17,12.26-22.53h-32.53c-2.31,5.33-5.91,9.6-10.8,12.8-4.89,3.2-11.06,4.8-18.53,4.8-6.76,0-12.84-1.55-18.26-4.67-5.43-3.11-9.69-7.69-12.8-13.73-2.64-5.12-4.15-11.08-4.55-17.86h100.67c.35-2.31.53-4.53.53-6.67v-5.87c0-12.27-2.67-23.33-8-33.2-5.33-9.86-12.89-17.73-22.66-23.6ZM884.98,196.8c.73-5.13,2.12-9.62,4.19-13.47,3.2-5.95,7.55-10.44,13.06-13.46,5.51-3.02,11.55-4.53,18.13-4.53,9.24,0,16.97,2.8,23.2,8.4,6.22,5.6,9.51,13.29,9.87,23.06h-68.44Z'
        />
        <path
          className='cls-2'
          d='M1110.75,161.07c-4.45-6.93-10.45-12.31-18-16.13-7.56-3.82-16.4-5.73-26.53-5.73-12.44,0-23.59,3.07-33.46,9.2-9.87,6.13-17.56,14.49-23.07,25.06-5.51,10.58-8.27,22.62-8.27,36.13s2.71,25.6,8.13,36.26c5.42,10.67,13.02,19.02,22.8,25.06,9.78,6.04,20.89,9.07,33.33,9.07,7.64,0,14.31-1.07,20-3.2,5.69-2.13,10.58-4.93,14.67-8.4,4.08-3.47,7.55-7.15,10.4-11.06l1.63,9.89c.42,2.55,1.66,4.79,3.43,6.46,2.06,1.94,4.83,3.12,7.84,3.12h19.1V84.81h-32v76.26ZM1106.21,231.73c-3.2,6.4-7.73,11.42-13.6,15.07-5.87,3.65-12.62,5.47-20.27,5.47s-13.86-1.82-19.73-5.47c-5.87-3.64-10.45-8.67-13.73-15.07-3.29-6.4-4.93-13.77-4.93-22.13s1.64-15.73,4.93-22.13c3.29-6.4,7.87-11.37,13.73-14.93,5.87-3.55,12.44-5.33,19.73-5.33s14.4,1.78,20.27,5.33c5.87,3.56,10.4,8.53,13.6,14.93,3.2,6.4,4.8,13.78,4.8,22.13s-1.6,15.73-4.8,22.13Z'
        />
        <path
          className='cls-2'
          d='M1259.05,214.13c0,8.36-1.47,15.42-4.4,21.2-2.93,5.78-6.93,10.18-12,13.2-5.06,3.02-10.8,4.53-17.2,4.53-9.96,0-17.38-2.97-22.26-8.93-4.89-5.95-7.33-14.71-7.33-26.26v-75.46h-32v78.66c0,12.98,2.04,23.86,6.13,32.66,4.08,8.8,10,15.38,17.73,19.73,7.73,4.35,17.02,6.53,27.86,6.53s19.33-2.31,27.06-6.93c7.73-4.62,13.64-10.84,17.73-18.66l1.31,12.19c.31,2.9,1.69,5.46,3.72,7.28,2.03,1.83,4.72,2.93,7.64,2.93h17.99v-134.38h-31.99v71.72Z'
        />
        <path
          className='cls-2'
          d='M1311.1,257.88c0,5.22,2.12,9.95,5.54,13.37,3.42,3.42,8.15,5.54,13.37,5.54h88.81v-26.4h-71.72l65.84-76.82c1.56-1.82,2.75-3.9,3.51-6.13.68-1.96,1.03-4.04,1.03-6.15,0-5.34-2.22-10.17-5.79-13.6-3.39-3.27-8.01-5.27-13.09-5.27h-86.44v26.66h68.52l-65.09,76.56c-1.41,1.66-2.52,3.54-3.28,5.55-.8,2.12-1.22,4.39-1.22,6.69Z'
        />
        <path
          className='cls-2'
          d='M1437.53,257.88c0,5.22,2.12,9.95,5.54,13.37,3.42,3.42,8.15,5.54,13.37,5.54h88.81v-26.4h-71.72l65.84-76.82c1.42-1.65,2.53-3.52,3.29-5.52.82-2.14,1.25-4.43,1.25-6.76,0-5.34-2.22-10.17-5.79-13.6-3.39-3.27-8.01-5.27-13.09-5.27h-86.44v26.66h68.52l-65.09,76.56c-1.4,1.65-2.5,3.51-3.26,5.5-.82,2.14-1.25,4.43-1.25,6.75Z'
        />
      </g>
      <g>
        <path
          className='cls-1'
          d='M762.23,117.32h-206.4c15.34-17.15,34.9-30.45,57.05-38.27,14.44-5.11,29.97-7.89,46.16-7.89s30.63,2.59,44.64,7.35c22.77,7.75,42.86,21.26,58.56,38.81Z'
        />
        <path
          className='cls-1'
          d='M795.57,186.55h-273.09c1.32-7.94,3.33-15.65,5.96-23.07h55.18c10.37,0,20.67-1.3,30.65-3.85,8.53-2.18,16.83-5.27,24.75-9.23l9.24-4.62c8.42-4.21,17.26-7.43,26.34-9.62,9.49-2.29,19.24-3.46,29.06-3.46h70.48c14.02,20.89,19.35,41.51,21.41,53.85Z'
        />
        <path
          className='cls-1'
          d='M797.5,209.64c0,17.28-3.1,32.65-7.89,46.16h-261.16c-2.63-7.42-4.64-15.14-5.96-23.09h14.98c10.36,0,20.64-1.3,30.61-3.84,8.55-2.18,16.86-5.27,24.8-9.24l9.21-4.61c8.37-4.18,17.15-7.39,26.19-9.58,9.54-2.31,19.34-3.5,29.22-3.5h139.78c.15,2.55.22,5.11.22,7.7Z'
        />
        <path
          className='cls-1'
          d='M783.1,271.17c-5.56,11.21-12.6,21.54-20.87,30.77-13.69,15.3-30.74,27.54-49.98,35.56-16.38,6.83-34.35,10.59-53.21,10.59-16.19,0-31.72-2.78-46.16-7.89-22.15-7.82-41.71-21.12-57.05-38.27h27.81c10.37,0,20.67-1.3,30.65-3.85,8.53-2.18,16.83-5.26,24.75-9.22l9.24-4.62c8.42-4.21,17.26-7.43,26.35-9.62,9.48-2.29,19.23-3.45,29.05-3.45h79.43Z'
        />
      </g>
      <g>
        <path
          className='cls-2'
          d='M119.6,274.98v-135.05h17.15l1.34,20.36c4.11-7.5,9.82-13.31,17.15-17.42,7.32-4.11,15.45-6.16,24.38-6.16,6.79,0,13.04.98,18.76,2.95,5.71,1.97,10.72,4.92,15,8.84,4.29,3.93,7.77,9.02,10.45,15.27,4.29-8.39,10.49-15.01,18.62-19.83,8.13-4.82,16.83-7.23,26.12-7.23,10.36,0,19.38,2.06,27.06,6.16,7.68,4.11,13.62,10.36,17.82,18.76,4.19,8.4,6.3,19.02,6.3,31.89v81.46h-18.76v-79.31c0-14.29-2.91-24.96-8.71-32.02-5.81-7.05-14.07-10.58-24.79-10.58-7.15,0-13.67,1.92-19.56,5.76-5.9,3.84-10.5,9.38-13.8,16.61-3.31,7.23-4.96,16.21-4.96,26.93v72.61h-18.76v-79.31c0-14.29-2.95-24.96-8.84-32.02-5.9-7.05-14.03-10.58-24.38-10.58-7.5,0-14.16,1.92-19.96,5.76-5.81,3.84-10.41,9.47-13.8,16.88-3.4,7.41-5.09,16.57-5.09,27.46v71.81h-18.76Z'
        />
        <path
          className='cls-2'
          d='M365.31,333.93l33.23-73.95h-7.23l-53.32-120.04h20.36l46.09,107.18,48.5-107.18h19.29l-87.35,193.99h-19.56Z'
        />
      </g>
    </svg>
  );
}

interface IProps {
  match: any;
}

const Downloads = ({ match }: IProps) => {
  const { downloads, downloadFile, isDownloading, downloadingUrl, readyToSaveId } = useDownload(match?.params?.hash ?? '');

  return (
    <div className='fixed top-1/2 left-1/2 max-h-[95vh] w-137.5 max-w-[95%] -translate-1/2'>
      <div className='text-center'>
        <Logo />
      </div>

      <Card className='mt-8 max-h-[70vh] overflow-auto'>
        <Table
          dataSource={downloads}
          rowKey='url_download'
          pagination={false}
          loading={isDownloading}
          locale={{ emptyText: 'Nenhum arquivo encontrado' }}
          columns={[
            {
              title: 'Arquivo',
              dataIndex: 'name',
              ellipsis: true
            },
            {
              title: 'Extensão',
              dataIndex: 'extension',
              responsive: ['sm'],
              render: extension => <Typography.Text className='uppercase'>{extension}</Typography.Text>
            },
            {
              title: '',
              key: 'download',
              align: 'right',
              render: (_, file) => (
                <Tooltip title={readyToSaveId === file.id ? 'Salvar arquivo' : 'Baixar Conteúdo'} placement='top'>
                  <Button
                    aria-label={readyToSaveId === file.id ? `Salvar ${file.name}` : `Baixar ${file.name}`}
                    shape='circle'
                    type='text'
                    loading={downloadingUrl === file.url_download}
                    icon={<Icon.Download />}
                    onClick={() => downloadFile(file)}
                  />
                </Tooltip>
              )
            }
          ]}
        />
      </Card>
      <Typography.Text type='secondary' className='block px-0 py-5 text-center text-xs'>
        {new Date().getFullYear()} © Eduzz – Todos os direitos reservados
      </Typography.Text>
    </div>
  );
};

export default Downloads;
